import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ProblemReportDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export interface SubmitProblemReportParams {
  requestId: string;
  reason: string;
  /** Optional free-text detail (the screen gates only on a reason being picked). */
  description?: string;
  lat: number;
  long: number;
  /** Optional photo backing the report. */
  evidence?: Blob;
}

/**
 * Files a deferred problem report: upload the optional evidence first, then
 * file the report itself (reason + optional detail + geo-stamp). It does not
 * touch the delivery state machine — the delivery already happened normally.
 */
export const submitProblemReport = createAsyncThunk<
  void,
  SubmitProblemReportParams,
  { dispatch: ProblemReportDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.SUBMIT_PROBLEM_REPORT, async (params, { extra }) => {
  const { problemReportRepo: repo } = extra;
  const { requestId, reason, description, lat, long, evidence } = params;

  if (evidence) {
    await repo.uploadEvidence({ requestId, image: evidence });
  }
  await repo.fileReport({ requestId, reason, description, lat, long });
});
